var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.9c0 .603-.485 1.1-1.101 1.1v-.012h-5.092V12.26h2.605l.391-3.017h-2.996v-1.93c0-.875.249-1.467 1.492-1.467h1.599v-2.71a21.84 21.84 0 00-2.333-.118c-2.31 0-3.884 1.408-3.884 3.988V9.23H8.076v3.018h2.605v7.74h-9.58A1.099 1.099 0 010 18.887V1.1C0 .497.485 0 1.101 0H18.9c.603 0 1.1.485 1.1 1.1v17.8z",
    fill: "#002131"
  })));
}

export default SvgFacebook;